import { render, staticRenderFns } from "./AreaGroupDialog.vue?vue&type=template&id=6fbcbeb3&scoped=true&"
import script from "./AreaGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AreaGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./AreaGroupDialog.vue?vue&type=style&index=0&id=6fbcbeb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcbeb3",
  null
  
)

export default component.exports